import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/global.css';

// On-screen DevTools console for mobile debugging. Loads only when ?debug=1
// is in the URL, so it's not in the bundle for normal users. Adds:
//   1. Eruda for live inspection
//   2. A global console buffer (window.__logs)
//   3. A floating "Copy logs" button that copies the entire buffer
if (new URLSearchParams(window.location.search).get('debug') === '1') {
  const buffer: string[] = [];
  const original = {
    log: console.log,
    info: console.info,
    warn: console.warn,
    error: console.error
  };
  const stringify = (a: unknown): string => {
    if (typeof a === 'string') return a;
    try { return JSON.stringify(a); } catch { return String(a); }
  };
  (Object.keys(original) as Array<keyof typeof original>).forEach((level) => {
    console[level] = (...args: unknown[]): void => {
      const ts = new Date().toISOString().slice(11, 23);
      buffer.push(`[${ts}] ${level.toUpperCase()} ${args.map(stringify).join(' ')}`);
      if (buffer.length > 5000) buffer.shift();
      original[level].apply(console, args);
    };
  });
  (window as unknown as { __logs: string[] }).__logs = buffer;

  const s = document.createElement('script');
  s.src = 'https://cdn.jsdelivr.net/npm/eruda';
  s.onload = () => (window as unknown as { eruda: { init: () => void } }).eruda.init();
  document.body.appendChild(s);

  const btn = document.createElement('button');
  btn.textContent = 'Copy logs';
  btn.style.cssText = [
    'position:fixed', 'bottom:12px', 'left:12px', 'z-index:2147483647',
    'padding:8px 12px', 'background:#222', 'color:#fff', 'border:1px solid #555',
    'border-radius:6px', 'font:14px/1 sans-serif', 'opacity:0.85'
  ].join(';');
  btn.onclick = (): void => {
    const text = buffer.join('\n');
    navigator.clipboard.writeText(text).then(
      () => { btn.textContent = `Copied ${buffer.length} lines`; setTimeout(() => { btn.textContent = 'Copy logs'; }, 2000); },
      () => { window.prompt('Clipboard failed — long-press to select & copy:', text); }
    );
  };
  document.body.appendChild(btn);
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
